import { ISessionStore } from 'stores/SessionStore';
// eslint-disable-next-line import/no-extraneous-dependencies
import { TelegramWebApps } from 'telegram-webapps';

export type TUseTelegram = {
  isTelegram: boolean;
  onClose: () => void;
  onToggleButton: () => void;
  tg: TelegramWebApps.WebApp;
  user: TelegramWebApps.WebAppUser;
  queryId: string;
  listener: (store: ISessionStore) => void;
};

// eslint-disable-next-line @typescript-eslint/dot-notation
const isTelegram: boolean = !!window['Telegram'];
const tg: TelegramWebApps.WebApp = (isTelegram ? Telegram.WebApp : {}) as TelegramWebApps.WebApp;

export function useTelegram() {
  const listener = (store: ISessionStore) => {
    window.addEventListener('message', (event) => {
      if (typeof event?.data === 'string') {
        try {
          const data = JSON.parse(event.data);
          if (data?.eventType === 'viewport_changed') {
            store.tgWidth(+data.eventData.width);
          }
        } catch (e) {
          //
        }
      }
    });
  };

  const onClose = () => {
    if (!isTelegram) return;
    tg.close();
  };

  const onToggleButton = () => {
    if (!isTelegram) return;
    if (tg.MainButton.isVisible) {
      tg.MainButton.hide();
    } else {
      tg.MainButton.show();
    }
  };

  return {
    isTelegram: isTelegram && tg.initDataUnsafe?.user,
    onClose,
    onToggleButton,
    tg,
    user: isTelegram ? tg.initDataUnsafe?.user : {},
    queryId: isTelegram ? tg.initDataUnsafe?.query_id : '',
    listener,
  } as unknown as TUseTelegram;
}
